import * as ActionTypes from '../components/actions/types';

const initState = {
  openGeneralLoader: false,
  openCoverImageLoader: false
};

function loaderReducer(state = initState, action) {
  switch (action.type) {
    case ActionTypes.LOADER_ACTIVATE: {
      return { ...state, openGeneralLoader: true };
    }
    case ActionTypes.LOADER_DEACTIVATE: {
      return { ...state, openGeneralLoader: false };
    }
    case ActionTypes.EVENT_FORM_COVER_IMAGE_LOADER_ACTIVATE: {
      return { ...state, openCoverImageLoader: true };
    }
    case ActionTypes.EVENT_FORM_COVER_IMAGE_LOADER_DEACTIVATE: {
      return { ...state, openCoverImageLoader: false };
    }
    default: {
      return state;
    }
  }
}

export default loaderReducer;



// WEBPACK FOOTER //
// ./src/reducers/loader.js